
export const ClinicalStatus: { [key: number]: string } = {
    2: "Clinically Active",
    3: "Clinically Inactive",
    6: "Clinically Active Not Enough For PIP"
}